import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrgDepartmentsModalComponent } from './org-departments-modal.component';
import {
  BannerModule,
  ButtonModule,
  EmptyStateSearchModule,
  InputsModule,
  TagsModule,
  ToggleModule,
  TooltipModule as XrefTooltipModule
} from '@xref/xref-lib';
import { SortV2Module } from '../sort-v2/sort-v2.module';
import { AppPaginationModule } from '../pagination/pagination.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SearchCoreModule } from '../search-core/search-core.module';
import { LoaderModule } from '../loader/loader.module';


@NgModule({
  declarations: [OrgDepartmentsModalComponent],
  imports: [
    CommonModule,
    BannerModule,
    ButtonModule,
    TagsModule,
    ToggleModule,
    XrefTooltipModule,
    SortV2Module,
    SearchCoreModule,
    InputsModule,
    ButtonModule,
    AppPaginationModule,
    LoaderModule,
    TooltipModule.forRoot(),
    EmptyStateSearchModule
  ],
  exports: [OrgDepartmentsModalComponent]
})
export class OrgDepartmentsModalModule { }
